import React from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from 'styled-components'
import { MarginSize, MARGIN_VALUES, PrintScale } from './paperConfig'
import { PageBreak } from './pageBreakUtils'

const BADGE_COLOR = '#ff4d4f'

const BreakLineWrapper = styled.div`
  position: absolute;
  left: -8px;
  right: -8px;
  pointer-events: none;
  z-index: 10;
`

const BreakLine = styled.div`
  border-top: 1.5px dashed ${BADGE_COLOR};
  opacity: 0.5;
`

const BadgeContainer = styled.div<{ $marginMm: number; $counterZoom: number }>`
  position: absolute;
  right: -${({ $marginMm }) => $marginMm}mm;
  top: -10px;
  display: flex;
  align-items: center;
  transform: scale(${({ $counterZoom }) => $counterZoom});
  transform-origin: right center;
`

const BadgeArrow = styled.div`
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 8px solid ${BADGE_COLOR};
`

const BadgeLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background: ${BADGE_COLOR};
  padding: 2px 8px;
  border-radius: 0 3px 3px 0;
  white-space: nowrap;
  line-height: 16px;
`

interface PageBreakOverlayProps {
  breaks: PageBreak[]
  margin: MarginSize
  scale: PrintScale
}

const PageBreakOverlay: React.FC<PageBreakOverlayProps> = ({ breaks, margin, scale }) => {
  const { t } = useTranslation()
  const marginMm = MARGIN_VALUES[margin]
  const counterZoom = 100 / scale

  return (
    <>
      {breaks.map(b => (
        <BreakLineWrapper key={`break-page-${b.pageNumber}`} data-print-ignore style={{ top: b.y }}>
          <BreakLine />
          <BadgeContainer $marginMm={marginMm} $counterZoom={counterZoom}>
            <BadgeArrow />
            <BadgeLabel>{t('customReportPrint:pageBreakLabel', { number: b.pageNumber })}</BadgeLabel>
          </BadgeContainer>
        </BreakLineWrapper>
      ))}
    </>
  )
}

export default PageBreakOverlay
